import { render, staticRenderFns } from "./talk_job.vue?vue&type=template&id=79cda6be&scoped=true&"
import script from "./talk_job.vue?vue&type=script&lang=js&"
export * from "./talk_job.vue?vue&type=script&lang=js&"
import style0 from "./talk_job.vue?vue&type=style&index=0&lang=css&"
import style1 from "./talk_job.vue?vue&type=style&index=1&id=79cda6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cda6be",
  null
  
)

export default component.exports